import { REDUX_ACTIONS, GAME_ID } from '../../data/constants';

const initState = {
  isOnboarded: false,
};

const screenReducer = (state = initState, { type, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.COMPLETE_ONBOARDING:
      return {
        ...state,
        isOnboarded: true,
      };

    default:
      return state;
  }
};

export default screenReducer;
